export default "__VITE_ASSET__172f6b59__"